// Remembers the admin's last-picked "rows per page" for each server-paginated
// DataGrid (Patients, Diet Master, Diet Plans, Payments), keyed separately
// per list so choosing 25 on one list doesn't force 25 everywhere else.
const STORAGE_PREFIX = 'dietist_page_size_';

export function getStoredPageSize(key, fallback = 10) {
  try {
    const stored = window.localStorage.getItem(STORAGE_PREFIX + key);
    const parsed = parseInt(stored, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
  } catch {
    return fallback;
  }
}

export function setStoredPageSize(key, pageSize) {
  try {
    window.localStorage.setItem(STORAGE_PREFIX + key, String(pageSize));
  } catch {
    // localStorage unavailable (private browsing etc.) — not worth failing over.
  }
}
